<template>
  <div class="tasks">
    <div
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
        class="mdi"
        :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
        @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="filter" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="select">
        <fg-input
            type="text"
            v-model="filter.fid"
            :placeholder="translate('task.device_fid')"
            :label="translate('task.device_fid')"
            @input="change_input"
        />
      </div>

      <div class="select">
        <label> {{ translate('task.status') }} </label>
        <tree-select
            :options="statuses_list"
            v-model="filter.status"
            :multiple="false"
            :clearable="true"
            :placeholder="translate('task.status')"
            @input="change_input"
        />
      </div>

      <div class="select">
        <label> {{ translate('task.type') }} </label>
        <tree-select
            :options="commands_list"
            v-model="filter.commands"
            :multiple="true"
            :clearable="true"
            :placeholder="translate('task.type')"
            @input="change_input"
        />
      </div>

      <div class="select"></div>
      <div class="select"></div>
      <div class="select"></div>
    </div>

    <div class="response_table" >
      <table>
        <thead>
        <tr>
          <th class="w7per">{{ translate('task.id') }}</th>
          <th class="w50"><span class="sr-only">{{ translate('task.device_status') }}</span></th>
          <th>{{ translate('task.device_fid') }}</th>
          <th>{{ translate('task.type') }}</th>
          <th>{{ translate('task.command_text') }}</th>
          <th>{{ translate('task.output_preview') }}</th>
          <th class="w7per">{{ translate('task.status') }}</th>
          <th>{{ translate('task.username') }}</th>
          <th class="w7per">{{ translate('task.ts') }}</th>
        </tr>
        </thead>
        <tbody ref="tableTask">
        <tr v-for="(task, key) in tasks" :key="key">
          <td :data-label="translate('task.id')" class="w7per">
            {{ task.id }}
          </td>
          <td :data-label="translate('task.device_status')" class="w50 device_status">
            <span
                v-if="task.device_status != null"
                class="mdi"
                :class="Number(task.device_status) === 1 ? 'mdi-access-point online' : 'mdi-access-point-off'"
                :title="translate(Number(task.device_status) === 1 ? 'device_status_list.online' : 'device_status_list.offline')"
                :aria-label="translate(Number(task.device_status) === 1 ? 'device_status_list.online' : 'device_status_list.offline')"
                role="img"
            />
          </td>
          <td :data-label="translate('task.device_fid')" class="device_name">
            <router-link :to="{path: '/device/' + task.device_fid}" class="link">
              {{ task.device_fid }}
            </router-link>
            <p>{{ task.device_name }}</p>
          </td>
          <td :data-label="translate('task.type')">
            {{ task.command }}
          </td>
          <td :data-label="translate('task.command_text')">
            {{ task.command_text }}
          </td>
          <td :data-label="translate('task.output_preview')">
            {{ task.output_preview }}
          </td>
          <td class="w7per" :data-label="translate('task.status')">
            {{ task.status }}
          </td>
          <td :data-label="translate('task.username')">
            <router-link :to="{path: '/user/' + task.username}" class="link">
              {{ task.username }}
            </router-link>
          </td>
          <td class="w7per" :data-label="translate('task.ts')" v-html="get_date_any_lines(task.ts, null, 2)">
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>
<script>

export default {
  name: 'Tasks',
  data () {
    return {
      tasks: [],
      filter:{
        fid: "",
        status: null,
        commands: []
      },
      statuses: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },
  computed:{
    commands_list(){
      return [
        {id: 18, label: "RPC"},
        {id: 16, label: "SELFTEST"},
        {id: 9, label: "SYNC_CONFIG"},
        {id: 20, label: "REGISTRATION"},
        {id: 17, label: "BLOCK_MODEM"},
      ]
    },
    statuses_list(){
      return this.statuses.map((item) => {
        return { id: item.status, label: item.name}
      })
    }
  },
  created () {
    this.check_query()
  },
  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'task_list_section') {
          let string = '?'
          for (let key in this.filter) {
            switch (key) {
              case 'fid':
              case 'status':
                if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                  string += `&${key}=${this.filter[key]}`
                }
                break;
              case 'commands':
                if (this.filter[key].length > 0){
                  string += `&${key}=${this.filter[key]}`
                }
                break;
            }
          }
          history.replaceState(null, null, this.$route.path + string)
        }
      }
    },
  },
  methods: {
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'fid':
            case 'status':
              this.filter[key] = this.$route.query[key]
              break;

            case 'commands':
              this.filter[key] = this.$route.query[key].split(',').map(item => {
                return Number(item)
              })
              break;

          }
        }
      }
      this.getTaskStatuses()
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getTasks, 500)
    },
    getTaskStatuses(){
      this.$http.v1.getTaskStatuses((response) => {
        this.statuses = response.data
        this.getTasks()
      })
    },
    getTasks(){
      let filter = {}
      for (let key in this.filter) {
        if (key === "commands"){
          if (this.filter[key].length > 0){
            filter[key] = this.filter[key]
          }
        }
        else {
          if (this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
            filter[key] = this.filter[key]
          }
        }
      }

      this.$http.v1.getTasks(filter, (response) => {
        if (response.data){
          this.tasks = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}

</script>
<style lang="scss" scoped>
.tasks{
  height: 100%;
  padding-top: 30px;
  display: flex;
  flex-direction: column;

  .filter{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    & > div{
      flex: 1;
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .form-group{
      margin-bottom: 0;
    }
  }
  .response_table{
    flex: 8;
    overflow: auto;
    padding: 0;
    &::-webkit-scrollbar {
      width: 10px;
    }
    .link{
      color: #3091B2;
    }
    .device_status{
      font-size: 22px;
      .online{
        color: #15ab00;
      }
    }
    .device_name{
      a,p{
        font-size: 12px;
        margin-bottom: 0;
      }
    }
  }
}

</style>
